import { gql } from "@apollo/client"
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";
import { MutationResponseWithId } from "../../sharedTypes";

//query for available firmware systems
export const ALLFIRMWARESYSTEMS_INFO = gql`
query System($version: String) {
  system {
    availableFirmware(version: $version)
  }
}`;

export type AllFirmwareSystems_Data = {
  availableFirmware: string[];
}

//call for what firmware system is on 

export const FIRMWARESYSTEM_INFO = gql`
query Config($domain: String!, $lanControllerId: Int!) {
  controller {
    config(domain: $domain, lanControllerId: $lanControllerId) {
      firmwareVersion
    }
  }
}`;

export interface LCFirmwareArgs { 
  domain: string
  lanControllerId: number
}

export interface LCFirmwareResponse {
  controller: {
    config?: {firmwareVersion: string}
  }
}

export type FirmwareSystem_Data = {
  firmwareVersion: string;
}

//mutation to update firmware

export const UPDATEFIRMWARE_SYSTEM = gql`
mutation FirmwareUpdate($domain: String!, $lanControllerId: Int!, $fileName: String!) {
  controller {
    firmwareUpdate(domain: $domain, lanControllerId: $lanControllerId, fileName: $fileName) {
      code
      success
      message
    }
  }
}`;

export interface UpdateFirmwareResponse {
  controller: {
    firmwareUpdate: Def_MutationResponse;
  }
}
export interface UpdateFirmwareArgs {
  domain: string;
  lanControllerId: number;
  fileName: string;
}


export const FIRMWARE_UPDATE_ABORT = gql`
mutation FirmwareUpdateAbort($domain: String!, $lanControllerId: Int!) {
  controller {
    firmwareUpdateAbort(domain: $domain, lanControllerId: $lanControllerId) {
      code
      success
      message
    }
  }
}
`;

export interface FirmwareUpdateAbortResponse {
  controller: {
    firmwareUpdateAbort: Def_MutationResponse;
  }
}

export interface FirmwareUpdateAbortArgs {
  domain: string;
  lanControllerId: number;
}


export const FIRMWARE_UPDATE_CAN = gql`
mutation FirmwareUpdateCAN($domain: String!, $fileName: String!, $deviceRegisterIds: [Int!]!, $isDirect: Boolean!) {
  device {
    firmwareUpdateCAN(domain: $domain, fileName: $fileName, deviceRegisterIds: $deviceRegisterIds, isDirect: $isDirect) {
      code
      message
      success
      id
    }
  }
}
`;

export interface FirmwareUpdateCANResponse {
  device: {
    firmwareUpdateCAN: MutationResponseWithId[] | null;
  }
}

export interface FirmwareUpdateCANArgs {
  domain: string;
  deviceRegisterIds: number[];
  fileName: string;
  isDirect: boolean;
}


export type FirmwareVersion = {
  fileName: string
}

export const AVAILABLE_FIRMWARE_LC = gql`
query AvailableFirmware($domain: String!) {
  controller {
    availableFirmware(domain: $domain) {
      fileName
    }
  }
}
`;

export interface AvailableFirmwareLCResponse {
  controller: {
    availableFirmware: FirmwareVersion[];
  }
}

export interface AvailableFirmwareLCArgs {
  domain: string;
}


export const AVAILABLE_FIRMWARE_DEVICE = gql`
query AvailableFirmware($domain: String!) {
  device {
    availableFirmware(domain: $domain) {
      fileName
    }
  }
}
`;

export interface AvailableFirmwareDeviceResponse {
  device: {
    availableFirmware: FirmwareVersion[];
  }
}

export interface AvailableFirmwareDeviceArgs {
  domain: string;
}
